import { ProductOperationParams } from '@repo/accounts-types'
import { createDownloadSlice } from '@repo/core'

export const {
  actions: productOperationsMasterListDownloadActions,
  reducer: productOperationsMasterListDownloadReducer,
} = createDownloadSlice<ProductOperationParams>('@accounts/master/list/operationsDownload')
